
<div class="hr-layout">
  <!-- <app-hygine-sidebar></app-hygine-sidebar> -->
  <div class="hr-main-content">
    <div class="hr-report-panel" >
    <div class="hr-page-outer">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="hr-page-wrap">
            <div class="hr-header-row">
            <div class="hr-header-top">
              <h1 class="hr-main-title">Hygiene / Staff Attendance</h1>
              <div class="hr-segment-groups" role="group" aria-label="Filters">
                <div class="hr-segment-pair" aria-label="School or College">
                  <button type="button" class="hr-segment-btn" [class.hr-segment-active]="schoolOrCollege === 'COLLEGE'"
                    (click)="selectSchoolOrCollege('COLLEGE')">College</button>
                  <button type="button" class="hr-segment-btn" [class.hr-segment-active]="schoolOrCollege === 'SCHOOL'"
                    (click)="selectSchoolOrCollege('SCHOOL')">School</button>
                </div>
                <span class="hr-segment-divider" aria-hidden="true"></span>
                <div class="hr-segment-pair" aria-label="Residential or Day scholar">
                  <button type="button" class="hr-segment-btn" [class.hr-segment-active]="boardingSegment === 'RESIDENTIAL'"
                    (click)="selectBoarding('RESIDENTIAL')">Residential</button>
                  <button type="button" class="hr-segment-btn" [class.hr-segment-active]="boardingSegment === 'DAY_SCHOLAR'"
                    (click)="selectBoarding('DAY_SCHOLAR')">Day scholar</button>
                </div>
              </div>
            </div>
            <div class="hr-filter-bar-wrapper">
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openState(); focusStateInput()"
                  [class.hr-trigger-open]="stateOpen">
                  <span class="hr-trigger-text">{{ stateTriggerText }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="stateOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search State"
                      [(ngModel)]="stateQuery" (keyup)="filterStates()" #searchStateInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let s of filteredStateList">
                      <ul class="att-dropdown-item" (mousedown)="selectState(s); $event.preventDefault()"
                        [class.att-item-selected]="selectedStateId === (s.stateId ?? s.id)">
                        <li class="att-item-text">{{ s.stateName ?? s.name ?? s }}</li>
                        <li><i *ngIf="selectedStateId === (s.stateId ?? s.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openCity(); focusCityInput()"
                  [class.hr-trigger-open]="cityOpen">
                  <span class="hr-trigger-text">{{ selectedCityName || 'Select City' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="cityOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search City"
                      [(ngModel)]="cityQuery" (keyup)="filterCities()" #searchCityInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let c of filteredCityList">
                      <ul class="att-dropdown-item" (mousedown)="selectCity(c); $event.preventDefault()"
                        [class.att-item-selected]="selectedCityId === (c.cityId ?? c.id)">
                        <li class="att-item-text">{{ c.cityName ?? c.name ?? c }}</li>
                        <li><i *ngIf="selectedCityId === (c.cityId ?? c.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openCampus(); focusCampusInput()"
                  [class.hr-trigger-open]="campusOpen">
                  <span class="hr-trigger-text">{{ selectedCampusName || 'Select Campus' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="campusOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search Campus"
                      [(ngModel)]="campusQuery" (keyup)="filterCampuses()" #searchCampusInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let c of filteredCampusList">
                      <ul class="att-dropdown-item" (mousedown)="selectCampus(c); $event.preventDefault()"
                        [class.att-item-selected]="selectedCampusId === (c.campusId ?? c.id)">
                        <li class="att-item-text">{{ c.campusName ?? c.name ?? c }}</li>
                        <li><i *ngIf="selectedCampusId === (c.campusId ?? c.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <span class="hr-filter-sep"></span>
              <div class="hr-combobox">
                <div class="hr-combobox-trigger" (click)="openBuilding(); focusBuildingInput()"
                  [class.hr-trigger-open]="buildingOpen">
                  <span class="hr-trigger-text">{{ selectedBuildingName || 'Select Building' }}</span>
                  <span class="hr-trigger-chevron"><i class="fa fa-chevron-down"></i></span>
                </div>
                <div class="hr-combobox-panel" *ngIf="buildingOpen">
                  <div class="att-search-container">
                    <input type="text" class="form-control att-search-input" placeholder="Search Building"
                      [(ngModel)]="buildingQuery" (keyup)="filterBuildings()" #searchBuildingInput
                      (mousedown)="$event.stopPropagation()">
                  </div>
                  <div class="list_campus">
                    <ng-container *ngFor="let b of filteredBuildingList">
                      <ul class="att-dropdown-item" (mousedown)="selectBuilding(b); $event.preventDefault()"
                        [class.att-item-selected]="selectedBuildingId === (b.buildingId ?? b.id)">
                        <li class="att-item-text">{{ b.buildingName ?? b.name ?? b }}</li>
                        <li><i *ngIf="selectedBuildingId === (b.buildingId ?? b.id)" class="fa fa-check att-check-icon"></i></li>
                      </ul>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="hr-filter-bar-spacer"></div>
              <button type="button" class="hr-search-btn" (click)="onSearch()">
                <i class="fa fa-search"></i> Search
              </button>
            </div>
          </div>

         
          <div class="row hr-cards-row">
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-purple" [class.hr-card-active]="activeDateTab === 'today'"
                (click)="selectDateTab('today')" role="button" tabindex="0">
                <i class="fa fa-camera hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Today's Photo</span>
                  <span class="hr-summary-value">{{ reportData?.todayPhotoCount ?? 0 }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-orange" [class.hr-card-active]="activeDateTab === 'yesterday'"
                (click)="selectDateTab('yesterday')" role="button" tabindex="0">
                <i class="fa fa-calendar-minus hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Yesterday's Photo</span>
                  <span class="hr-summary-value">{{ reportData?.yesterdayPhotoCount ?? 0 }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-green" [class.hr-card-active]="activeDateTab === 'last7'"
                (click)="selectDateTab('last7')" role="button" tabindex="0">
                <i class="fa fa-calendar-week hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">Last 7 day's</span>
                  <span class="hr-summary-value">{{ reportData?.last7DaysPhotoCount ?? 0 }}</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="hr-summary-card hr-card-red" [class.hr-card-active]="activeDateTab === 'month'"
                (click)="selectDateTab('month')" role="button" tabindex="0">
                <i class="fa fa-calendar-alt hr-summary-icon"></i>
                <div class="hr-summary-text">
                  <span class="hr-summary-label">This Month</span>
                  <span class="hr-summary-value">{{ reportData?.thisMonthPhotoCount ?? 0 }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- One white card: tabs, content, grid, pagination inside (same as dashboard) -->
          <div class="hr-main-card">
            <!-- Tabs + Compare -->
            <div class="hr-tabs-row">
              <div class="hr-date-tabs">
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'today'"
                  (click)="selectDateTab('today')">Today</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'yesterday'"
                  (click)="selectDateTab('yesterday')">Yesterday</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'last7'"
                  (click)="selectDateTab('last7')">Last 7 days</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'month'"
                  (click)="selectDateTab('month')">This Month</button>
                <button type="button" class="hr-tab" [class.hr-tab-active]="activeDateTab === 'custom'"
                  (click)="selectDateTab('custom')">Custom Date</button>
              </div>
               <button type="button" class="hr-excel-btn" (click)="exportToExcel()" title="Export to Excel">
                <i class="fa fa-file-excel-o"></i>Overall Staff Report
              </button>
              <button type="button" class="hr-excel-btn" (click)="exportToExcelStaff()" title="Export to Excel">
                <i class="fa fa-file-excel-o"></i> Staff Details Report
              </button>
              <!-- <button type="button" class="hr-compare-btn" (click)="showCompare = !showCompare">Compare</button> -->
            </div>


            <div class="hr-custom-date-wrap" *ngIf="activeDateTab === 'custom'">
              <div class="hr-date-range-input-wrap">
                <input #dateRangeInput type="text" class="hr-date-range-input"
                  placeholder="Select Date Range" readonly>
                <i class="fa fa-calendar hr-date-range-icon"></i>
              </div>
              <span class="hr-date-range-hint">Select start date and end date</span>
            </div>

            <h2 class="hr-content-heading">{{ activeDateTab === 'today' ? "Today's Pictures" : activeDateTab === 'yesterday' ? "Yesterday's Pictures" : activeDateTab === 'last7' ? "Last 7 Days' Pictures" : activeDateTab === 'month' ? "This Month's Pictures" : "Pictures" }} ({{ reportData?.pictures?.length ?? 0 }})</h2>

            <!-- Picture grid - from API response (fileName, departmentName, employeeCount, hygieneDate) - 10 per page -->
             <div class="hr-pictures-grid">
              <div class="hr-pic-card" *ngFor="let p of paginatedPictures" (click)="openImageDialog(p)">
                <div class="hr-pic-placeholder">
                  <img *ngIf="p.fileName" [src]="p.fileName" [alt]="p.departmentName" class="hr-pic-img"
                    (error)="onImageError(p.imageRefId)">
                  <i *ngIf="!p.fileName || imageErrorIds.has(p.imageRefId)" class="fa fa-image"></i>
                </div>
               <div *ngIf="p.campusName || p.buildingName" class="hr-pic-campus-below">
                  <span class="hr-pic-campus-text">{{ (p.campusName || '') + (p.campusName && p.buildingName ? ' · ' : '') + (p.buildingName || '') }}</span>
                  <span *ngIf="p.latitude != null && p.longitude != null" class="hr-pic-map-icon-wrap" (mousedown)="onMapIconClick($event, p.latitude, p.longitude)" (click)="$event.stopPropagation(); $event.preventDefault()" role="button" tabindex="0" (keydown.enter)="onMapIconClick($event, p.latitude, p.longitude)">
                  <img [src]="mapIconPath" alt="Map" class="hr-pic-location-icon hr-pic-location-clickable">
                </span>
                </div>
                <div class="hr-pic-employee-below" *ngIf="(p.employeeName || p.designation || p.mobileNo) || (p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName || p.staffDetails?.[0]?.designation || p.staffDetails?.[0]?.mobileNo)">
                  <span *ngIf="p.employeeName || p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName" class="hr-pic-employee-line">{{ p.employeeName || p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName }}</span>
                  <span *ngIf="p.designation || p.staffDetails?.[0]?.designation" class="hr-pic-employee-line">{{ p.designation || p.staffDetails?.[0]?.designation }}</span>
                  <span *ngIf="p.mobileNo || p.staffDetails?.[0]?.mobileNo" class="hr-pic-employee-line">{{ p.mobileNo || p.staffDetails?.[0]?.mobileNo }}</span>
                </div>
                <div class="hr-pic-info">
                  <div class="hr-pic-dept-row">
                    <span class="hr-pic-dept">{{ p.activityName || p.departmentName }}</span>
                    <span class="hr-pic-staff" *ngIf="p.employeeCount != null">{{ p.employeeCount }} staff</span>
                  </div>
                  <div class="hr-pic-meta">
                    <span class="hr-pic-datetime">{{ getPictureDateTime(p) }}</span>
                  </div>
                </div>
              </div>
              <p *ngIf="reportData && (!reportData.pictures || reportData.pictures.length === 0)" class="hr-no-pictures">No pictures found.</p>
            </div>

            <!-- Pagination: 10 cards per page -->
             <div class="hr-pagination" *ngIf="totalPictures > 0">
              <button type="button" class="hr-page-btn" [disabled]="currentPage <= 1" (click)="setPage(currentPage - 1)">Previous</button>
              <button type="button" class="hr-page-btn hr-page-skip" [disabled]="currentPage <= 1" (click)="goBack10()">Back 10</button>
              <ng-container *ngFor="let slot of paginationSlots">
                <span *ngIf="slot === 'ellipsis'" class="hr-page-ellipsis">…</span>
                <button *ngIf="slot !== 'ellipsis'" type="button" class="hr-page-num" [class.hr-page-active]="currentPage === slot" (click)="setPage(slot)">{{ slot }}</button>
              </ng-container>
              <button type="button" class="hr-page-btn hr-page-skip" [disabled]="currentPage >= totalPages" (click)="goForward10()">Forward 10</button>
              <button type="button" class="hr-page-btn" [disabled]="currentPage >= totalPages" (click)="setPage(currentPage + 1)">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
  <!-- <div class="hr-compare-panel" *ngIf="showCompare">
    <app-hygiene-compare (back)="showCompare = false"></app-hygiene-compare>
  </div> -->
  </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
